export default __webpack_public_path__ + "static/media/IMG_5061.4e5c1546.jpg";